import store from "../store";
import HvfView from "./hvfView";
import {getSameDateExams, getExamsWithUniqueDate} from  "../helpers/utils";
export default class HvfMultiviewContext {
  constructor(exam){
    this.componentName="hvfMultiviewBody";
    this.browserName="HVF MULTIVIEW";

    this.isComparisonContext = true;
    this.ptSrNo = exam.ptSrNo;
    this.exam = exam;
    this.exSrNo = exam.exSrNo;

    this.exams = [];
    this.views = [];
    this.allHvFExams = store.getters.visualFieldExams.sort((a, b) => b.moment.diff(a.moment));
  }

  clearContext(){
    store.commit("clearImageQueue", "imageQueue");
    this.views.forEach(v => v.clear());
    this.exam = null;
    this.exams = null;
    this.views = null;
  }

  startupTask() {
    this.exams = getExamsWithUniqueDate(this.allHvFExams);
    
    let exSrNos = this.allHvFExams.map(e => e.exSrNo);

    return store.dispatch("loadExamImageMetadata", {exSrNos}).then(() => {
      this.exam = this.exams[0];
      this.views = [
        new HvfView(this.exam),
        new HvfView(this.exams[1] || this.exam),
        new HvfView(this.exams[2] || this.exams[1] || this.exam)
      ];

      for (const v of this.views){
        let sameDateExams = getSameDateExams(this.allHvFExams, v.exam.dateDisplay);
        v.setupView(sameDateExams);
      }

      this.refreshImages();
    });
  }

  refreshImages(){
    let images = this.views.map(v => v.images)
      .reduce((a, b) => a.concat(b))
      .filter((a, i, self) => self.indexOf(a) === i);
    return store.dispatch("loadImages_full_thumb", images);
  }

  selectHVFExam(exam, index){
    let view = this.views[index];
    if (!view) return;

    view.exam = exam;
    let sameDateExams = getSameDateExams(this.allHvFExams, exam.dateDisplay);
    view.image = null;
    view.setupView(sameDateExams)
    view.loadImages();

    if (index === 0) {
      this.exam = exam;
      this.exSrNo = exam.exSrNo;
    }
  }

  previousHVFImage(index) {
    let view = this.views[index];
    if (!view) return;

    view.prev();
  }

  nextHVFImage(index){
    let view = this.views[index];
    if (!view) return;

    view.next();
  }
}